export const U_DN_CLASS = 'u-dn';
export const NAJA_INIT_CLASS = 'init';
export const DEFAULT_TRANSITION_TIME = 250;

export const FORM_ROW = 'form-row';
export const FORM_ERROR = 'form-row--error';
export const FORM_ERROR_MSG_CLASS = 'form-row__error';
export const W_FORM_CLASS = 'w-form';
export const W_FORM_SUBMITTING_CLASS = 'w-form--submitting';

export function getNaja() {
  return window.najaGlobal;
};
